<template>
    <el-dialog
            :visible.sync="showModel"
            :modal="isModal"
            :show-close="false"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :modalAppendToBody="false"
            top="20%"
            width="80%"
            custom-class="registerDialog">

        <div class="contain">
            <img :src="icon" class="icon">
            <div class="title">帳號資訊</div>
            <div class="subtitle">同意後將帶入以下資料</div>
            <p></p>
            <div class="info">姓名 : {{name}}</div>
            <div class="info">手機 : {{phone}}</div>
            <div class="info">生日 : {{birthday}}</div>
            <div class="info">性別 : {{gender}}</div>
            <div class="info">Email : {{mail}}</div>
            <p></p>
            <p>
                <label class="agree">
                    <span>我已閱讀並同意</span>
                    <input type="checkbox" v-model="agree">
                    <span class="checkmark"></span>
                </label>
                <el-button class="rule" type="text" @click="$router.push({name: 'QrCodePrivacy'})">使用者條款</el-button>
            </p>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel" round v-show="isCancel" type="info">{{negativeLabel}}</el-button>
                <el-button @click="confirm" round :disabled="!agree" type="primary">{{positiveLabel}}</el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        name: "RegisterDialog",
        props: {
            icon: {default: require('@/assets/images/member2.svg')},
            outerContent: {default: "提醒"},
            positiveLabel: {default: "確定"},
            negativeLabel: {default: "取消"},
            value: {required: false, type: Boolean, default: false},        //是否顯示 dialog (dialog開關)?
            eventType: {required: false, type: Number, default: 0},            //事件種類辨認用，會在 result 中回傳，可以在顯示 dialog前設定好，在 result中以此來辨認目前是哪個事件的 result
            isCancel: {default: true},
            isModal: {default: true},
            name: {default: '--'},
            phone: {default: '--'},
            birthday: {default: '--'},
            gender: {default: '--'},
            mail: {default: '--'},
        },
        data() {
            return {
                showModel: this.value,
                agree: true,            //是否同意使用協議
            }
        },
        created() {

        },
        mounted() {

        },
        watch: {
            value: function () {
                this.showModel = this.value;
            }
        },
        methods: {
            cancel: function () {
                this.showModel = false;
                //回傳 result，外部接收到 result事件後再做處理
                // args1 : 是否確定？
                // args2 : 事件類型
                this.$emit('result', false, this.eventType, this.agree);
            },
            confirm: function () {
                this.showModel = false;
                //回傳 result，外部接收到 result事件後再做處理
                this.$emit('result', true, this.eventType, this.agree);
            }
        }
    }
</script>

<style lang="less" scoped>

    .rule {
        color: #7EABD6;
        cursor: pointer;
        padding: 0px;
        font-size: 14px;
    }

    .agree {
        display: inline-block;
        position: relative;
        cursor: pointer;
        font-size: 14px;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;

        input {
            position: absolute;
            opacity: 0;
            cursor: pointer;
            height: 0;
            width: 0;
        }

        .checkmark {
            position: absolute;
            top: 8px;
            left: -22px;
            height: 15px;
            width: 15px;
            background-color: #eee;
            border-radius: 10px;
            box-shadow: 0 0 0 1px #fff, 0 0 0 2px #666;

            &::after {
                position: absolute;
                left: 9px;
                top: 5px;
                width: 5px;
                height: 10px;
                border: 3px solid white;
            }
        }

        input:checked ~ .checkmark {
            background-color: #CBAE97;
            box-shadow: 0 0 0 1px #fff, 0 0 0 2px #666
        }

        input:checked ~ .checkmark:after {
            display: block;
        }
    }

    .contain {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;

        img {
            width: 70px;
            height: 70px;
            object-fit: cover;
        }

        .title {
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            height: 24px;
            font-size: 18px;
            line-height: 24px;
            margin-top: 12px;
            color: #595757
        }

        .subtitle {
            height: 20px;
            font-size: 14px;
            line-height: 20px;;
            color: #7f7f7f;
            margin-top: 10px
        }

        .info {
            text-overflow: ellipsis;
            width: 70%;
            height: 20px;
            font-size: 14px;
            line-height: 20px;
            margin-top: 3px;
            color: #bbb9b9;
        }
    }
</style>

